import AuthorInfo from '@/features/blog/detail/AuthorInfo';
import MetaItem from '@/features/blog/detail/MetaItem';
import { ArticleDetail } from '@/lib/contentful/api/getArticle';
import { BlogI18n } from '@/lib/i18n/blogI18n';

const ArticleMeta = ({ author, date, minRead, t }: ArticleMetaProps) => (
  <div className="flex flex-col gap-2 tablet:flex-row tablet:items-center tablet:flex-wrap tablet:gap-y-2">
    {author && <AuthorInfo author={author} />}
    <div className="flex items-center tablet:contents">
      <MetaItem className="pl-0 before:hidden tablet:pl-4 tablet:before:block">
        {date}
      </MetaItem>
      <MetaItem>
        {minRead} {t.minRead}
      </MetaItem>
    </div>
  </div>
);

export default ArticleMeta;

type ArticleMetaProps = {
  author: ArticleDetail['author'];
  date: string;
  minRead: number;
  t: BlogI18n;
};
